export default {
    hide_answered: false,
    current: {
        section: false, 
        response: false
    }
}